import { render } from "./PaymentScreens.vue?vue&type=template&id=b9e00074"
const script = {}

import exportComponent from "/Users/nika/Documents/Projects/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__